(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/coupon-single-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/coupon-single-rows.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
const {
  useContext,
  useState,
  useRef
} = React;
const {
  useSelector
} = ReactRedux;
const {
  SwipeArrows
} = svs.sport.swipeArrows;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  CouponSingleRow,
  CouponSingelRowsMobile,
  CouponSingelPixChoices,
  CouponSingleRowBetButtons
} = svs.components.tipsen.coupon;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  FrameBlur
} = svs.components.tipsen.frameBlur;
const {
  framePosition
} = svs.components.tipsen.frameBlur.constants;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const {
  selectAllBoardSelections
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  getProductBrandByDraw
} = svs.components.lbUtils.brandMapping.fn;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const CouponSingleRows = _ref => {
  let {
    couponId,
    events,
    outcomeLabels,
    selectedBoard
  } = _ref;
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const {
    productId,
    drawNumber
  } = useContext(DrawContext);
  const selections = useSelector(state => selectAllBoardSelections(state, couponId)) || [];
  const mappedBoards = [];
  for (let i = 0; i < selections.length; i++) {
    events.forEach(() => {
      if (!mappedBoards[i]) {
        mappedBoards.push([]);
      }
      mappedBoards[i].push(outcomeLabels);
    });
  }
  const [scrollElement, setScrollElement] = useState(null);
  const getLeftScroll = () => {
    const contentHolder = document.querySelector('.coupon-single-rows-board-columns');
    return contentHolder.scrollLeft - contentHolder.clientWidth;
  };
  const getRightScroll = () => {
    const contentHolder = document.querySelector('.coupon-single-rows-board-columns');
    const clientWidth = contentHolder.clientWidth;

    const colWidth = 114;

    const numberOfCols = Math.ceil(clientWidth / colWidth);
    return contentHolder.scrollLeft + numberOfCols * colWidth;
  };
  const leftArrowOffset = document.querySelector('.coupon-single-rows-event-column') ? document.querySelector('.coupon-single-rows-event-column').clientWidth - 24 : 190;
  const arrowVerticalPadding = 366;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const showArrows = !isSmall || isSelfService;
  const radioRefs = useRef(Array(mappedBoards.length).fill(null).map(() => Array(mappedBoards[0].length).fill(null).map(() => Array(mappedBoards[0][0].length).fill(null))));
  const getCompletedRowsSummary = () => {
    const completed = selections.map((board, boardIndex) => {
      const allMatchesHaveSelection = board.every(match => match.some(outcome => outcome === true));
      return allMatchesHaveSelection ? "Rad ".concat(boardIndex + 1) : null;
    }).filter(i => i !== null);
    if (completed.length === 0) {
      return 'Inga rader är färdiga.';
    }
    if (completed.length === 1) {
      return "En rad \u2013 ".concat(completed[0], " \xE4r f\xE4rdig.");
    }
    return "".concat(completed.length, " rader \u2013 ").concat(completed.join(', '), " \xE4r f\xE4rdiga.");
  };
  const getFullRowDescription = rowIndex => {
    const isComplete = selections[rowIndex].every(match => match.some(outcome => outcome === true));
    if (isComplete) {
      return "Rad ".concat(rowIndex + 1, ", fullst\xE4ndigt ifylld.");
    }
    const isPartial = !isComplete && selections[rowIndex].some(match => match.some(outcome => outcome === true));
    if (isPartial) {
      return "Rad ".concat(rowIndex + 1, ", delvis ifylld.");
    }
    return "Rad ".concat(rowIndex + 1, ", ej p\xE5b\xF6rjad");
  };
  const getAriaLabelForMatch = (rowIndex, matchIndex) => {
    let ariaLabel = "Utfall f\xF6r match ".concat(matchIndex + 1);
    const selectedArray = selections[rowIndex][matchIndex];
    const selectedOutcomeIndex = selectedArray.findIndex(outcome => outcome);
    if (selectedOutcomeIndex !== -1) {
      const selectedOutcome = outcomeLabels[selectedOutcomeIndex];
      ariaLabel += ", ".concat(selectedOutcome.ariaLabel);
    } else {
      ariaLabel += ', inget valt tecken';
    }
    return ariaLabel;
  };
  if (isSmall) {
    return React.createElement(CouponSingelRowsMobile, {
      couponId: couponId,
      events: events,
      outcomeLabels: outcomeLabels,
      radioRefs: radioRefs,
      selectedBoard: selectedBoard,
      selections: selections
    });
  }
  return React.createElement("div", {
    className: "coupon-single-rows"
  }, React.createElement("div", {
    className: "coupon-single-rows-event-column"
  }, events.map(drawEvent => React.createElement(CouponSingleRow, {
    branding: branding,
    drawNumber: drawNumber,
    event: drawEvent,
    isSingleRowForSmallDevice: isSmall,
    key: drawEvent.eventNumber,
    productId: productId
  }))), showArrows && React.createElement(React.Fragment, null, React.createElement(SwipeArrows, {
    arrowVerticalPadding: arrowVerticalPadding,
    getLeftScrollWidth: getLeftScroll,
    getRightScrollWidth: getRightScroll,
    leftArrowOffset: leftArrowOffset,
    scrollContentEl: scrollElement,
    scrollParentSelector: ".coupon-single-rows-board-columns"
  }), React.createElement(FrameBlur, {
    className: "single-rows-frame-blur",
    position: framePosition.START,
    scrollElement: scrollElement
  }), React.createElement(FrameBlur, {
    className: "single-rows-frame-blur",
    position: framePosition.END,
    scrollElement: scrollElement
  })), React.createElement("div", {
    className: "coupon-single-rows-board-columns qa-coupon-singlerow-columns",
    ref: node => {
      if (node) {
        setScrollElement(node);
      }
    }
  }, React.createElement("output", {
    "aria-atomic": "true",
    "aria-live": "polite",
    className: "aria-status sr-only"
  }, getCompletedRowsSummary()), selections.map((board, boardIndex) => {
    const key = "".concat(boardIndex + 1);
    const isRowCompleted = board.every(match => match.some(outcome => outcome === true));
    return React.createElement("div", {
      className: "coupon-single-rows-board",
      key: key
    }, React.createElement("fieldset", {
      "aria-label": getFullRowDescription(boardIndex),
      id: "row-".concat(boardIndex + 1)
    }, React.createElement("legend", {
      "aria-hidden": true,
      className: "coupon-single-rows-board-header f-200",
      id: "row-label-".concat(boardIndex + 1)
    }, boardIndex + 1), board.map((eventSelection, eventIndex) => {
      const selectedIndex = eventSelection.findIndex(outcome => outcome);
      const key = "".concat(boardIndex + 1, "_").concat(eventIndex + 1);
      return React.createElement("div", {
        "aria-label": getAriaLabelForMatch(boardIndex, eventIndex),
        className: "coupon-single-rows-bet-buttons",
        id: "srow-".concat(boardIndex + 1, "-match-").concat(eventIndex + 1),
        key: key,
        role: "radiogroup"
      }, React.createElement(CouponSingleRowBetButtons, {
        boardIndex: boardIndex,
        couponId: couponId,
        eventIndex: eventIndex,
        numOfBoards: mappedBoards.length,
        numOfEvents: mappedBoards[boardIndex].length,
        outcomeLabels: outcomeLabels,
        radioRefs: radioRefs,
        selectedIndex: selectedIndex,
        selections: selections
      }));
    })), React.createElement(CouponSingelPixChoices, {
      boardIndex: boardIndex,
      couponId: couponId
    }), isRowCompleted && React.createElement("a", {
      className: "coupon-single-rows-board-skip-to-pay",
      href: "#payButton"
    }, "Hoppa till betalning"));
  })));
};
setGlobal('svs.components.tipsen.coupon.CouponSingleRows', CouponSingleRows);

 })(window);